export default __webpack_public_path__ + "static/media/sortIconDown.93d647a5.svg";